<template>
  <div class="basic-image-container">
    <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
      <star-condition-cell label="镜像名称">
        <a-input v-model="searchCondition.dockerName" style="width: 100%"> </a-input>
      </star-condition-cell>

      <star-condition-cell label="镜像地址">
        <a-input v-model="searchCondition.dockerPath" style="width: 100%"> </a-input>
      </star-condition-cell>

      <star-condition-cell label="状态">
        <a-select allowClear v-model="searchCondition.dockerStatus" style="width: 100%">
          <a-select-option :value="1">运行中</a-select-option>
          <a-select-option :value="-1">已停用</a-select-option>
          <a-select-option :value="0">未启用</a-select-option>
        </a-select>
      </star-condition-cell>

      <star-condition-cell label="站点类型">
        <a-select allowClear v-model="searchCondition.spiderClassId" style="width: 100%">
          <a-select-option
            v-for="item in spiderClassOptions"
            :key="item.spiderClassId"
            :value="item.spiderClassId"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-container">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" @click="isShowCreateModal = true">
          <a-icon type="plus"></a-icon>
          新建
        </a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="dockerId"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="spiderClassId" slot-scope="text, record">
          {{ getClassNameById(record) }}
        </span>

        <span slot="dockerStatus" slot-scope="text, record">
          <a-badge v-if="record.dockerStatus === 1" color="blue" text="运行中"> </a-badge>
          <a-badge
            v-if="record.dockerStatus === -1"
            color="rgba(0,0,0,0.4)"
            text="已停用"
          ></a-badge>
          <a-badge v-if="record.dockerStatus === 0" color="gold" text="未启用"></a-badge>
        </span>

        <span slot="action" slot-scope="text, record">
          <a-button type="link" v-if="record.dockerStatus === 1" @click="onClose(record)">停用</a-button>
          <a-button type="link" v-if="record.dockerStatus === 0" @click="onOpen(record)">启用</a-button>
          <a-button type="link" v-if="record.dockerStatus === -1" @click="onOpen(record)">重启</a-button>
          <a-divider type="vertical" />
          <a-button type="link" @click="showModifyImageModal(record)">编辑</a-button>
          <a-divider type="vertical" />
          <a-popconfirm title="确定要删除吗?" @confirm="() => onDeleteImage(record)">
             <a-button type="link">删除</a-button>
          </a-popconfirm>

        </span>
      </a-table>
    </div>

    <a-modal v-model="isShowCreateModal" title="新建镜像" @ok="onSubmitNewImage">
      <a-form-model
        ref="ruleForm"
        :model="newImage"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item ref="dockerName" label="镜像名称" prop="dockerName">
          <a-input v-model="newImage.dockerName" />
        </a-form-model-item>

        <a-form-model-item ref="dockerPath" label="镜像地址" prop="dockerPath">
          <a-input v-model="newImage.dockerPath" />
        </a-form-model-item>

        <a-form-model-item ref="spiderClassId" label="站点类型" prop="spiderClassId">
          <a-select v-model="newImage.spiderClassId">
            <a-select-option
              v-for="item in spiderClassOptions"
              :key="item.spiderClassId"
              :value="item.spiderClassId"
              >{{ item.spiderClassName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="dockerDesc" label="镜像描述" prop="dockerDesc">
          <a-textarea v-model="newImage.dockerDesc" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="isShowModifyModal" title="修改镜像" @ok="onSubmitModifyImage">
      <a-form-model
        ref="ruleFormModify"
        :model="modifyImage"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item ref="name" label="镜像名称" prop="name">
          <a-input v-model="modifyImage.dockerName" />
        </a-form-model-item>

        <a-form-model-item ref="addr" label="镜像地址" prop="addr">
          <a-input v-model="modifyImage.dockerPath" />
        </a-form-model-item>

        <a-form-model-item ref="type" label="站点类型" prop="type">
          <a-select v-model="modifyImage.spiderClassId">
            <a-select-option
              v-for="item in spiderClassOptions"
              :key="item.spiderClassId"
              :value="item.spiderClassId"
              >{{ item.spiderClassName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item ref="desc" label="镜像描述" prop="desc">
          <a-textarea v-model="modifyImage.dockerDesc" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      v-model="isShowSelectNewImageModal"
      title="镜像替换"
      @ok="onChangeImage"
      :confirm-loading="modalSubmitloading"
    >
      <p>选择替换的镜像:</p>
      <a-select v-model="willOpenImageId" style="width: 100%">
        <a-select-option
          v-for="item in notOpenImageList"
          :key="item.dockerId"
          :value="item.dockerId"
          >{{ item.dockerName }}
        </a-select-option>
      </a-select>
    </a-modal>
  </div>
</template>

<script>
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import {
  getBasicImageListApi,
  getAllBasicImageNotOpenListApi,
  createBasicImageApi,
  modifyBasicImageApi,
  modifyBasicImageStatusApi,
  deleteBasicImageApi
} from '@/api/System/BasicImage'
import { onHttpResponse, onHttpResponseSilent } from '@/utils/request'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'

export default {
  components: { TableHeadIcons },
  mixins: [tableSettingToStoreMixin()],

  data() {
    return {
      searchCondition: {
        dockerName: '',
        dockerPath: '',
        dockerStatus: '',
        spiderClassId: ''
      },
      spiderClassOptions: [],
      tableData: [],
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '镜像名称',
          dataIndex: 'dockerName',
          ellipsis: true,
          show: true
        },
        {
          title: '路径',
          dataIndex: 'dockerPath',
          show: false
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassId',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'spiderClassId' }
        },
        {
          title: '状态',
          dataIndex: 'dockerStatus',
          show: true,
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'dockerStatus' }
        },
        {
          title: '创建时间',
          align: 'center',
          width: 150,
          dataIndex: 'createTime',
          show: true
        },
        {
          title: '最近启用时间',
          dataIndex: 'openTime',
          show: true,
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'openTime' }
        },
        {
          title: '停用时间',
          dataIndex: 'closeTime',
          show: false,
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'closeTime' }
        },
        {
          title: '描述',
          dataIndex: 'dockerDesc',
          show: true,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'dockerDesc' }
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 180,
          align: 'center'
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      loading: false,
      tableDensity: 'middle',
      isShowColFilterOverlay: false,

      isShowCreateModal: false,
      newImage: {
        dockerName: '',
        dockerPath: '',
        spiderClassId: '',
        dockerDesc: ''
      },

      isShowModifyModal: false,
      modifyImage: {},

      rules: {
        dockerName: { required: true, message: '镜像名为必填项', trigger: 'blur' },
        dockerPath: { required: true, message: '地址为必填项', trigger: 'blur' },
        spiderClassId: { required: true, message: '类型为必选项', trigger: 'blur' }
      },

      notOpenImageList: [],

      isShowSelectNewImageModal: false,
      willCloseImageId: 0,
      willOpenImageId: '',
      modalSubmitloading: false
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    this.querySpiderClassInfo()
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.getBasicImageList()
    },

    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },

    reset() {
      this.searchCondition = {
        dockerName: '',
        dockerPath: '',
        dockerStatus: '',
        spiderClassId: ''
      }
      this.handleSearch()
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getBasicImageList()
    },

    getBasicImageList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchCondition
      }

      this.loading = true
      getBasicImageListApi(query)
        .then((res) => {
          let { code, msg, data, extra } = res
          if (code === 200) {
            this.tableData = data
            this.pagination.total = extra.page.pageCount || 0
          } else {
            this.$message.error(msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    getClassNameById(record) {
      return (
        this.spiderClassOptions.filter((o) => o.spiderClassId === record.spiderClassId)[0]
          ?.spiderClassName || '未知'
      )
    },

    onSubmitNewImage() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          createBasicImageApi(this.newImage).then((res) => {
            if (res.code === 200) {
              this.$message.success('创建成功')
              this.newImage = {
                dockerName: '',
                dockerPath: '',
                spiderClassId: '',
                dockerDesc: ''
              }
              this.isShowCreateModal = false
              this.handleSearch()
            } else {
              this.$message.error(res.msg)
            }
          })
        }

        return valid
      })
    },

    showModifyImageModal(record) {
      if (record.dockerStatus === 1) {
        this.$warning({
          title: '运行中的镜像不可编辑',
          content: ''
        })
        return
      }
      this.modifyImage = {
        ...record
      }
      this.isShowModifyModal = true
    },

    onSubmitModifyImage() {
      this.$refs.ruleFormModify.validate((valid) => {
        if (valid) {
          modifyBasicImageApi(this.modifyImage).then((res) => {
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.modifyImage = {}
              this.isShowModifyModal = false
              this.getBasicImageList()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
        }

        return valid
      })
    },

    onDeleteImage(record) {
      if (record.dockerStatus === 1) {
        this.$warning({
          content: '运行中的镜像不可删除'
        })
        return
      }
      this.$confirm({
        content: '镜像删除将无法恢复，是否确认删除？',
        onOk: () => {
          return deleteBasicImageApi({ dockerId: record.dockerId })
            .then(onHttpResponse)
            .then(() => {
              this.getBasicImageList()
              return
            })
            .catch(() => {})
        }
      })
    },

    onClose(record) {
      getAllBasicImageNotOpenListApi({ spiderClassId: record.spiderClassId })
        .then(onHttpResponseSilent)
        .then((res) => {
          this.notOpenImageList = res.data.filter((d) => d.dockerId !== record.dockerId)
          if (this.notOpenImageList.length === 0) {
            this.$warning({
              content: '当前无可替代的镜像版本，不可停用，请新增该站点类型的镜像！'
            })
            return
          }
          this.willCloseImageId = record.dockerId
          this.willOpenImageId = ''
          this.isShowSelectNewImageModal = true
        })
        .catch(() => {})
    },

    onOpen(record) {
      this.$confirm({
        title: '确认开启',
        content:
          '同一站点类型只可运行一个镜像版本，若启用该镜像，则正在运行的镜像将自动停用，是否确认启用该镜像？',
        onOk: () => {
          return modifyBasicImageStatusApi({ dockerId: record.dockerId, dockerStatus: 1 })
            .then(onHttpResponse)
            .then(() => {
              this.getBasicImageList()
              return
            })
            .catch(() => {})
        }
      })
    },

    onChangeImage() {
      // 切换镜像
      if (!this.willOpenImageId) {
        this.$message.warn('请选择替换的镜像')
        return
      }
      this.modalSubmitloading = true
      modifyBasicImageStatusApi({
        dockerId: this.willCloseImageId,
        dockerStatus: -1,
        newDockerId: this.willOpenImageId
      })
        .then(onHttpResponse)
        .then(() => {
          this.getBasicImageList()
          this.isShowSelectNewImageModal = false
          return
        })
        .catch(() => {})
        .finally(() => {
          this.modalSubmitloading = false
        })
    }
  }
}
</script>
<style lang="less" scoped>
.basic-image-container {
  width: 100%;
  padding: 16px;

  .search-condition-inner {
    width: 100%;
    padding: 16px;
    background: white;
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;

    .conditions {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .condition {
        width: 24%;
        padding-right: 30px;
        display: flex;
        align-items: center;

        .label {
          margin-right: 10px;
        }

        .input {
          flex: 1;
        }
      }
    }

    .actions {
      flex-shrink: 0;
      width: 200px;
      display: flex;
      flex-direction: row-reverse;
      gap: 8px;
    }
  }

  .table-container {
    background-color: white;
    padding: 0 16px;
    margin-top: 16px;
  }
}
</style>
